'use strict';

angular.module('msWidgets').directive('msWidgetCopyH2', [function () {
  return {
    templateUrl: 'widgets/templates/copy/h2.html'
  };
}]).directive('msWidgetCopyH3', [function () {
  return {
    templateUrl: 'widgets/templates/copy/h3.html'
  };
}]).directive('msWidgetCopyH4', [function () {
  return {
    templateUrl: 'widgets/templates/copy/h4.html'
  };
}]).directive('msWidgetCopyLabel', [function () {
  return {
    templateUrl: 'widgets/templates/copy/label.html'
  };
}]).directive('msWidgetCopyQuote', [function () {
  return {
    templateUrl: 'widgets/templates/copy/quote.html'
  };
}]).directive('msWidgetCopyParagraph', [function () {
  return {
    templateUrl: 'widgets/templates/copy/paragraph.html'
  };
}]).directive('msWidgetCopyInstructions', [function () {
  return {
    templateUrl: 'widgets/templates/copy/instructions.html'
  };
}]);